import React from "react";
import styles from "./Header.module.css";
import Link from "next/link";
import { useRouter } from "next/router";
function Header({ style }) {
  const router = useRouter();
  const handleRestartQuiz = () => {
    localStorage.removeItem("recommendedProducts");
    localStorage.removeItem("quizAnswers");
    localStorage.removeItem("quiz_user_email");
    router.push("/");
  };
  return (
    <>
      <div className={styles.headerDiv}>
        <div className={styles.headerMain} style={style}>
          <div className={styles.ancor}>
            <Link href="/quiz">Mediterranean Longevity Quiz</Link>
          </div>
          <div onClick={handleRestartQuiz} className={styles.imagediv}>
            {" "}
            <img src="/images/BrunoLogo.png" alt="BrunoLogo" />
          </div>
          <div className={styles.closeDiv}>
            <Link href="/">Exit Quiz</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
